import type { PlacementId } from '@schibsted-nmp/advertising-shared';

export function isMiddlePlacement(placementId: PlacementId | string): boolean {
  return placementId.startsWith('advt_middle_');
}
